import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import JsonData from "../JsonData/jsonData.json";
import "./styles.css";
import { Navigation, Mousewheel, Keyboard, Autoplay } from 'swiper/modules';

const Testimonials = () => {
  const sliderRef = useRef(null);

  const handlePrev = () => {
    if (sliderRef.current && sliderRef.current.swiper) {
      sliderRef.current.swiper.slidePrev();
    }
  };

  const handleNext = () => {
    if (sliderRef.current && sliderRef.current.swiper) {
      sliderRef.current.swiper.slideNext();
    }
  };

  return (
    <section className="w-full py-16 space-y-10 select-none md:py-20 bg-gradient-to-t from-[#060E23] to-[#183889]">
      <div className="flex flex-col w-full gap-4 px-4 mx-auto 2xl:w-9/12 xl:w-11/12 xl:px-0">
        <div className="flex flex-col justify-between w-full gap-4 px-4 pb-5 mx-auto md:flex-row lg:items-center">
          <div className='space-y-2'>
            <h1 className="xl:text-5xl text-4xl leading-[3rem] xl:leading-[4rem] capitalize text-white font-bold">
              Hear from our trusted partners
            </h1>
          </div>
          <div className='flex flex-row items-center gap-4'>
            <div className="prev-arrow md:w-12 w-10 md:h-12 h-10 bg-gray-100 hover:bg-[#E91E63] hover:text-white rounded-full cursor-pointer flex justify-center items-center  transition-all duration-150 text-gray-600" onClick={handlePrev}>
              <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-chevron-left" width="28" height="28" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M15 6l-6 6l6 6"></path>
              </svg>
            </div>
            <div className="next-arrow md:w-12 w-10 md:h-12 h-10 bg-gray-100 hover:bg-[#E91E63] hover:text-white rounded-full cursor-pointer flex justify-center items-center  transition-all duration-150 text-gray-600" onClick={handleNext}>
              <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-chevron-right" width="28" height="28" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M9 6l6 6l-6 6"></path>
              </svg>
            </div>
          </div>
        </div>
        <Swiper
          ref={sliderRef}
          navigation={false}
          keyboard={true}
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          slidesPerView={1}
          spaceBetween={20}
          breakpoints={{
            640: { slidesPerView: 1, spaceBetween: 20 },
            768: { slidesPerView: 1, spaceBetween: 30 },
            1024: { slidesPerView: 2, spaceBetween: 40 },
            1440: { slidesPerView: 2, spaceBetween: 40 },
            1920: { slidesPerView: 2, spaceBetween: 40 }
          }}
          modules={[Autoplay, Navigation, Mousewheel, Keyboard]}
          className="2xl:w-9/12 xl:w-11/12 w-11/12 mx-auto mySwiper min-h-auto rounded-2xl"
        >
          {JsonData.testimonials.map((testimonial, index) => {
            return (
              <SwiperSlide key={index} className="h-auto rounded-xl">
                <div className="w-full flex flex-col shrink-0 snap-start p-8 lg:p-10 ">
                  <div className="max-w-2xl h-full">
                    <div className="flex flex-col gap-6">
                      <img src="/img/home/quote.svg" alt="Quote" className="w-12 h-12" />
                      <p className="text-base text-[#212121] font-display text-left font-medium italic">{testimonial.quote}</p>
                      <div className="block flex-shrink-0">
                        <div className="flex items-center">
                          <div>
                            <img className="inline-block h-16 w-16 rounded-full object-cover object-center" src={testimonial.image} alt="" />
                          </div>
                          <div className="ml-4 text-[#212121]">
                            <p className="text-lg font-semibold text-left">{testimonial.name}</p>
                            <p className="text-sm font-medium">{testimonial.position}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>

      </div>

    </section>
  );
};

export default Testimonials;
